import Common from 'js/_core/Common'

import ViewController from 'js/app/controllers/ViewController'
import TeamsModal from 'js/modules/projects/ui/TeamsModal'
import TeamsNavCurrentUI from 'js/modules/projects/ui/TeamsNavCurrentUI'

export default class TeamsViewController extends ViewController {
  constructor(content) {
    super(content)
    if (this.debug) {
      this.pageName = '[Teams]'
    }

    // ページ別のコンテンツ(html)はここからアクセスできます
    this.$content = content
    this.teamsModal = new TeamsModal({
      $contentRoot: this.$content,
    })

    this.teamsNavCurrentUI = new TeamsNavCurrentUI({
      $contentRoot: this.$content,
    })
  }

  async willLoad() {
    await super.willLoad()
  }

  async didLoad() {
    await super.didLoad()
  }

  async beforeEnter() {
    await super.beforeEnter()
    this.teamsModal.init()
    this.teamsNavCurrentUI?.init()
  }

  async enter() {
    this.addHandlers()
    await super.enter()
    this._addObservers()
  }

  async afterEnter() {
    await super.afterEnter()
  }

  async beforeLeave() {
    await super.beforeLeave()
    this._removeObservers()
    this.removeHandlers()
  }

  async leave() {
    await super.leave()
  }

  async afterLeave() {
    await super.afterLeave()
  }

  _set$() {
    super._set$()
  }

  addHandlers() {
    super.addHandlers()
    if (Common.resize) {
      Common.resize.addHandler(() => {
        this.onResize()
      }, 'TeamsViewControllerResize')
    }
  }

  removeHandlers() {
    super.removeHandlers()
    if (Common.resize) {
      Common.resize.removeHandler('TeamsViewControllerResize')
    }
  }

  _addObservers() {}

  _removeObservers() {}

  onResize() {
    super.onResize()
  }
}